import React from "react";
import { Link } from "react-router-dom";

const SaddleStorkImg = "/Images/Pels.png";

const SaddleBilledStork = () => {
  return (
    <>
      {/* ── HERO ── */}
      <section
        style={{
          height: "100vh",
          position: "relative",
          backgroundImage: `url(${SaddleStorkImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        {/* overlay */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            background: "linear-gradient(to bottom, rgba(0,0,0,.12), rgba(0,0,0,.48))",
          }}
        />

        <div
          style={{
            position: "relative",
            height: "100%",
            display: "flex",
            alignItems: "center",
            padding: "0 48px",
          }}
        >
          <div style={{ maxWidth: "680px", color: "#fff", marginTop: "64px" }}>

            {/* breadcrumb + badge */}
            <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "20px" }}>
              <span
                style={{
                  fontSize: "12px",
                  fontFamily: "'Helvetica Neue', Arial, sans-serif",
                  fontWeight: 600,
                  letterSpacing: "1px",
                  cursor: "pointer",
                }}
              >
                ← All Species
              </span>
              <span
                style={{
                  background: "#dc3545",
                  color: "#fff",
                  fontSize: "9px",
                  fontFamily: "'Helvetica Neue', Arial, sans-serif",
                  fontWeight: 700,
                  letterSpacing: "1.5px",
                  padding: "4px 10px",
                }}
              >
                LEAST CONCERN
              </span>
            </div>

            {/* heading */}
            <h1
              style={{
                fontFamily: "Georgia, 'Times New Roman', serif",
                fontSize: "clamp(3.5rem, 7vw, 5.2rem)",
                fontWeight: 400,
                lineHeight: 0.92,
                margin: "0 0 20px 0",
                letterSpacing: "-0.5px",
              }}
            >
              Saddle-Billed
              <br />
              Stork
            </h1>

            {/* scientific name */}
            <p
              style={{
                fontFamily: "Georgia, 'Times New Roman', serif",
                fontStyle: "italic",
                fontSize: "17px",
                color: "rgba(255,255,255,.85)",
                margin: "0 0 20px 0",
              }}
            >
              Ephippiorhynchus senegalensis · Wetlands · Sub-Saharan Africa
            </p>

            <hr style={{ borderColor: "rgba(255,255,255,.5)", margin: "0 0 24px 0", width: "520px", maxWidth: "100%" }} />

            {/* stats row */}
            <div style={{ display: "flex", gap: "48px" }}>
              {[
                { value: "250", label: "MATURE INDIVIDUALS IN SOUTH AFRICA" },
                { value: "Endangered", label: "SOUTH AFRICAN RED LIST" },
                { value: "150 cm", label: "TALLEST STORK ON EARTH" },
              ].map((stat, i) => (
                <div key={i}>
                  <div
                    style={{
                      fontFamily: "Georgia, 'Times New Roman', serif",
                      fontSize: "clamp(1.8rem, 3vw, 2.8rem)",
                      fontWeight: 400,
                      lineHeight: 1,
                      marginBottom: "6px",
                    }}
                  >
                    {stat.value}
                  </div>
                  <div
                    style={{
                      fontFamily: "'Helvetica Neue', Arial, sans-serif",
                      fontSize: "9px",
                      fontWeight: 600,
                      letterSpacing: "1.2px",
                      color: "rgba(255,255,255,.8)",
                      maxWidth: "120px",
                      lineHeight: 1.5,
                    }}
                  >
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>

          </div>
        </div>
      </section>

      {/* ── BODY ── */}
      <section style={{ background: "#f5f3ee", padding: "64px 0" }}>
        <div style={{ maxWidth: "1100px", margin: "0 auto", padding: "0 24px" }}>
          <div style={{ display: "flex", gap: "48px" }}>

            {/* ── LEFT SIDEBAR ── */}
            <div style={{ width: "240px", flexShrink: 0 }}>

              {/* donate card */}
              <div
                style={{
                  background: "#ece9e2",
                  padding: "20px",
                  marginBottom: "24px",
                }}
              >
                <h6
                  style={{
                    fontFamily: "Georgia, 'Times New Roman', serif",
                    fontSize: "15px",
                    fontWeight: 400,
                    margin: "0 0 8px 0",
                  }}
                >
                  Support This Work
                </h6>
                <p
                  style={{
                    fontSize: "12px",
                    color: "#666",
                    lineHeight: 1.7,
                    margin: "0 0 16px 0",
                    fontFamily: "'Helvetica Neue', Arial, sans-serif",
                  }}
                >
                  Field research, community programs, and habitat protection all depend on donations.
                </p>
                <Link to="/donate" style={{ textDecoration: "none" }}>
                  <button
                    style={{
                      width: "100%",
                      background: "#6d735d",
                      color: "#fff",
                      border: "none",
                      padding: "10px",
                      fontSize: "11px",
                      fontFamily: "'Helvetica Neue', Arial, sans-serif",
                      fontWeight: 700,
                      letterSpacing: "1.5px",
                      cursor: "pointer",
                    }}
                  >
                    DONATE
                  </button>
                </Link>
              </div>

              {/* related articles */}
              <div
                style={{
                  fontSize: "10px",
                  fontFamily: "'Helvetica Neue', Arial, sans-serif",
                  fontWeight: 600,
                  letterSpacing: "2px",
                  color: "#999",
                  textTransform: "uppercase",
                  marginBottom: "4px",
                }}
              >
                Related Articles
              </div>

              {[
                { to: "/african-penguin", label: "African Penguin →", status: "Critically Endangered" },
                { to: "/bearded-vulture", label: "Bearded Vulture →", status: "Nearly Threatened" },
                { to: "/cape-gannet", label: "Pel's Fishing Owl →", status: "VULNERABLE" },
              ].map((item, i) => (
                <div key={i} style={{ borderTop: "1px solid #ddd", padding: "12px 0" }}>
                  <Link
                    to={item.to}
                    style={{
                      textDecoration: "none",
                      color: "#222",
                      fontFamily: "Georgia, 'Times New Roman', serif",
                      fontSize: "14px",
                      display: "block",
                      marginBottom: "2px",
                    }}
                  >
                    {item.label}
                  </Link>
                  <small
                    style={{
                      fontFamily: "'Helvetica Neue', Arial, sans-serif",
                      fontSize: "11px",
                      color: "#888",
                    }}
                  >
                    {item.status}
                  </small>
                </div>
              ))}
            </div>

            {/* ── MAIN CONTENT ── */}
            <div style={{ flex: 1, minWidth: 0 }}>

              {/* intro + quick stats */}
              <div style={{ display: "flex", gap: "40px", marginBottom: "40px", alignItems: "flex-start" }}>
                <div style={{ flex: "0 0 55%" }}>
                  <p
                    style={{
                      fontFamily: "'Helvetica Neue', Arial, sans-serif",
                      fontSize: "13.5px",
                      lineHeight: 2,
                      color: "#555",
                      margin: 0,
                    }}
                  >
                    Standing nearly 1.5 meters tall with a wingspan of over 2.5 meters, the Saddle-billed
                    Stork is the tallest stork in the world and one of Africa's most visually spectacular
                    birds. Its crimson and black bill with a vivid yellow saddle is unmistakable. It wades
                    through African wetlands in search of fish, frogs, and crabs, and it has been doing so for
                    thousands of years.
                  </p>
                </div>

                <div style={{ flex: 1, display: "flex", gap: "0", justifyContent: "space-around", textAlign: "center" }}>
                  {[
                    { value: "5–6.9 kg (11–15.2 lbs.)", label: "Average Weight" },
                    { value: "5ft (150 cm)", label: "Average Height" },
                    { value: "12 years in the wild, over 30 in captivity", label: "Average Lifespan" },
                  ].map((s, i) => (
                    <div key={i} style={{ padding: "0 8px" }}>
                      <div
                        style={{
          fontFamily:
            "Hind Madurai,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif",
          fontSize: "17px",
          fontWeight: 600,
          marginBottom: "4px",
          lineHeight: 1.3,
        }}
                      >
                        {s.value}
                      </div>
                      <div
                        style={{
           fontFamily:
            "Hind Madurai,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif",
          fontSize: "14px",
          color: "#888",
        }}
                      >
                        {s.label}
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* personal note */}
              <div
                style={{
                  background: "#fff",
                  borderLeft: "3px solid #e0a320",
                  padding: "20px 24px",
                  marginBottom: "24px",
                }}
              >
                <div
                  style={{
                    fontFamily: "'Helvetica Neue', Arial, sans-serif",
                    fontSize: "10px",
                    fontWeight: 700,
                    letterSpacing: "1.5px",
                    color: "#c98d2c",
                    textTransform: "uppercase",
                    marginBottom: "12px",
                  }}
                >
                  A Personal Note
                </div>
                <p
                  style={{
                    fontFamily: "Georgia, 'Times New Roman', serif",
                    fontStyle: "italic",
                    fontSize: "17px",
                    lineHeight: 1.6,
                    color: "#333",
                    margin: 0,
                  }}
                >
                  "Something about the Saddle-billed Stork feels ancient — the way it moves through water, the absurd perfection of its bill. Losing it from the landscape would be like losing a color."
                </p>
              </div>

              {/* conservation status */}
              <div
                style={{
                  background: "#6d735d",
                  color: "#fff",
                  padding: "24px 28px",
                  marginBottom: "48px",
                }}
              >
                <div
                  style={{
                    fontFamily: "'Helvetica Neue', Arial, sans-serif",
                    fontSize: "10px",
                    fontWeight: 700,
                    letterSpacing: "2px",
                    textTransform: "uppercase",
                    marginBottom: "10px",
                    color: "rgba(255,255,255,.7)",
                  }}
                >
                  Conservation Status
                </div>
                <p
                  style={{
                    fontFamily: "'Helvetica Neue', Arial, sans-serif",
                    fontSize: "13.5px",
                    lineHeight: 1.85,
                    margin: 0,
                    color: "rgba(255,255,255,.92)",
                  }}
                >
                  The Saddle-billed Stork is listed as Near Threatened globally by the IUCN, with a suspected slow decline. In South Africa, at the southernmost limit of its range, it is listed as Endangered under national legislation, with fewer than 250 mature individuals. The core of its South African range falls within Kruger National Park, iSimangaliso Wetland Park, and associated protected areas — but threats to river and wetland systems within and beyond these parks continue to put pressure on the population. The full extent of the decline across its global range remains poorly understood.
                </p>
              </div>

              {/* why in trouble */}
              <h2
                style={{
                  fontFamily: "Georgia, 'Times New Roman', serif",
                  fontSize: "28px",
                  fontWeight: 400,
                  margin: "0 0 32px 0",
                }}
              >
                Why This Species Is In Trouble
              </h2>

              <div style={{ position: "relative", marginBottom: "40px" }}>
                {/* vertical line */}
                <div
                  style={{
                    position: "absolute",
                    left: "3px",
                    top: 0,
                    bottom: 0,
                    width: "1px",
                    background: "#ddd",
                  }}
                />

                {[
                  {
                    title: "Wetland Loss",
                    text: "Africa's floodplains are being drained, dammed, and converted to farmland at an accelerating rate. For a bird that depends entirely on shallow, productive wetlands to feed and breed, each lost floodplain is a piece of its world that simply disappears.",
                  },
                  {
                    title: "River Damming",
                    text: "Dams eliminate the seasonal flooding cycles that create the shallow, fish-rich wetlands these storks rely on. Without predictable flooding, the entire ecosystem that supports them collapses.",
                  },
                  {
                    title: "Pesticide Contamination",
                    text: "Agricultural chemicals running off into wetlands accumulate in the fish, frogs, and crabs that Saddle-billed Storks eat. The long-term effects on reproductive success are significant and poorly understood.",
                  },
                  {
                    title: "A Critically Small Population",
                    text: "Fewer than 250 mature individuals remain in South Africa. At that level, the species has almost no resilience to any additional pressure. A single severe drought season could have outsized consequences.",
                  },
                ].map((item, i) => (
                  <div key={i} style={{ display: "flex", marginBottom: "36px" }}>
                    <div
                      style={{
                        width: "8px",
                        height: "8px",
                        borderRadius: "50%",
                        background: "#c98d2c",
                        flexShrink: 0,
                        marginTop: "6px",
                        marginRight: "20px",
                        position: "relative",
                        zIndex: 2,
                      }}
                    />
                    <div>
                      <h6
                        style={{
                          fontFamily: "Georgia, 'Times New Roman', serif",
                          fontSize: "15px",
                          fontWeight: 600,
                          margin: "0 0 6px 0",
                        }}
                      >
                        {item.title}
                      </h6>
                      <p
                        style={{
                          fontFamily: "'Helvetica Neue', Arial, sans-serif",
                          fontSize: "13px",
                          lineHeight: 1.85,
                          color: "#666",
                          margin: 0,
                        }}
                      >
                        {item.text}
                      </p>
                    </div>
                  </div>
                ))}
              </div>

              {/* pull quote */}
              <div
                style={{
                  background: "#6d735d",
                  color: "#fff",
                  padding: "40px 44px",
                  margin: "0 0 48px 0",
                }}
              >
                <div
                  style={{
                    fontSize: "48px",
                    color: "#e0b04b",
                    lineHeight: 1,
                    marginBottom: "8px",
                    fontFamily: "Georgia, serif",
                  }}
                >
                  "
                </div>
                <p
                  style={{
                    fontFamily: "Georgia, 'Times New Roman', serif",
                    fontStyle: "italic",
                    fontSize: "22px",
                    lineHeight: 1.55,
                    margin: 0,
                  }}
                >
                  Where the Saddle-billed Stork walks, the wetland is alive. Where it has gone, something essential has been lost — not just a bird, but the health of an entire ecosystem.
                </p>
              </div>

              {/* what we're doing */}
              <h2
                style={{
                  fontFamily: "Georgia, 'Times New Roman', serif",
                  fontSize: "28px",
                  fontWeight: 400,
                  margin: "0 0 20px 0",
                }}
              >
                We're supporting the following activities
              </h2>

              <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginBottom: "48px" }}>
                {[
                  "Wetland restoration and legal protection in East and Southern Africa",
                  "Environmental flow advocacy in river management policy",
                  "Community wetland monitoring networks in key floodplain areas",
                  "International waterbird census coordination",
                  "Seasonal habitat mapping using aerial survey data",
                ].map((item, i) => (
                  <div
                    key={i}
                    style={{
                      background: "#fff",
                      border: "1px solid #e8e5df",
                      padding: "12px 16px",
                      display: "flex",
                      alignItems: "center",
                      fontFamily: "'Helvetica Neue', Arial, sans-serif",
                      fontSize: "13.5px",
                      color: "#333",
                    }}
                  >
                    <span style={{ color: "#c98d2c", marginRight: "12px", fontSize: "16px" }}>○</span>
                    {item}
                  </div>
                ))}
              </div>

              {/* reasons for hope */}
              <div style={{ background: "#6d735d", padding: "28px 32px", color: "#fff" }}>
                <div
                  style={{
                    fontFamily: "'Helvetica Neue', Arial, sans-serif",
                    fontSize: "10px",
                    fontWeight: 700,
                    letterSpacing: "2px",
                    textTransform: "uppercase",
                    color: "rgba(255,255,255,.7)",
                    marginBottom: "10px",
                  }}
                >
                  Reasons For Hope
                </div>
                <p
                  style={{
                    fontFamily: "'Helvetica Neue', Arial, sans-serif",
                    fontSize: "13.5px",
                    lineHeight: 1.85,
                    margin: "0 0 20px 0",
                    color: "rgba(255,255,255,.92)",
                  }}
                >
                  Wetland restoration projects in key floodplain regions are restoring habitat for multiple
                  species simultaneously. Greater policy awareness of environmental flows is creating
                  openings for protection.
                </p>
                <img
                  src="/Images/Pels2.png"
                  alt=""
                  style={{ width: "100%", display: "block" }}
                />
              </div>

            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SaddleBilledStork;